export default function BreadcrumbLink({ onClick, children }: { onClick: () => void; children: React.ReactNode }) {
    return (
        <span
            onClick={onClick}
            style={{
                color: '#4A7AF2',
                cursor: 'pointer',
                display: 'inline-block',
                padding: '2px 4px',
                margin: '-2px -4px',
                borderRadius: '4px',
                position: 'relative',
                zIndex: 1,
                pointerEvents: 'auto',
                transition: 'all 0.2s ease',
            }}
            onMouseEnter={e => { (e.currentTarget as HTMLElement).style.backgroundColor = 'rgba(74, 122, 242, 0.1)'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLElement).style.backgroundColor = 'transparent'; }}
        >
            {children}
        </span>
    );
}